module.exports = __webpack_public_path__ + "static/media/201cv253.c5e6b755.jpg";